import TitleM from "@common/components/text/TitleM"
import { HeaderContainerM } from "@common/header/HeaderContainerM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { liveService } from "@data/services/liveService"
import { useNavigation } from "@react-navigation/native"
import React, { useContext, useEffect, useRef } from "react"
import { View } from "react-native"
import { FlatList } from "react-native-gesture-handler"
import { ActivityIndicator, IconButton } from "react-native-paper"
import { connect } from "react-redux"
import TutorLiveCardComponent from "./TutorLiveCardComponent"

function TutorNextLivesListScreen(props) {
    const flatListRef = useRef()
    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()

    useEffect(() => {
        props.apiRequest(liveService.getLiveSessions)
    }, [])

    return (
        <View
            style={{
                flex: 1,
                width: "100%",
                alignSelf: "center",
                alignItems: "stretch",
            }}
        >
            <HeaderContainerM>
                <TitleM>Mes prochains Lives</TitleM>
                <IconButton
                    icon={"times"}
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    style={{
                        position: "absolute",
                        left: 4,
                    }}
                    onPress={() => {
                        if (navigation.canGoBack()) navigation.goBack()
                        else navigation.replace("menu")
                    }}
                />
            </HeaderContainerM>
            {props.getLiveSessionsRequest ? (
                <ActivityIndicator style={{ marginTop: 40 }} />
            ) : (
                <FlatList
                    data={props.liveSessionsList}
                    ref={flatListRef}
                    refreshing={!!props.getLiveSessionsRequest}
                    onRefresh={() => {
                        props.apiRequest(liveService.getLiveSessions)
                    }}
                    style={{
                        flex: 1,
                    }}
                    contentContainerStyle={{
                        alignItems: "center",
                    }}
                    renderItem={(item) => {
                        return (
                            <TutorLiveCardComponent
                                liveSession={item.item?.live_session}
                                style={{ width: dimensions?.width - 20 }}
                            />
                        )
                    }}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        students: state.data.currentUser?.object?.students,
        getLiveSessionsRequest: state.api.getLiveSessions?.request,
        interviewFinalizeSuccess: state.api.interviewFinalize?.success,
        users: state.data.users?.list,
        liveSessionsList: state.liveMode?.liveSessionsList,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TutorNextLivesListScreen)
